// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ProjectCreationExitModal_modalContent_oBSUQ","btnExit":"ProjectCreationExitModal_btnExit_20RVe","exitColor":"ProjectCreationExitModal_exitColor_3L-32"};